export class InsulationMaterialModel {
    _id: string;
    id: number;
    name: string;
    density: number;

    constructor(_id = null,
        id = null,
        name = '',
        density = null) {
            this._id = _id;
            this.id = id;
            this.name = name;
            this.density = density;
    }
}
